<template>
  <transition name="fade">
    <div class="modal-card-wrapper">
      <span @click="$emit('close')">&#x2715;</span>
      <div class="modal-card">
        <img src="@/assets/icon-upholstery-colors.svg" alt="Color upholstery logo">
        <div class="text">
          <b>Upholstery Color</b>
          Select from 9 colors or call<br />for 26 custom colors (+$90.00)
          <small><slot></slot></small>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modalcard'
}
</script>

<style lang="scss" scoped>
.modal-card-wrapper {
  width: 100%;
  max-width: 310px;
  height: 153px;
  background-color: var(--white);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 6px solid var(--black);
  position: relative;
  padding: 0 20px;
  z-index: 1000;
}

span {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
}

.modal-card {
  display: flex;
  height: 153px;
  align-items: center;
}

img {
  display: block;
  margin-right: 20px;
  margin-top: -40px;
  width: 32px;
}

.text {
  align-self: center;
  font-family: var(--roboto);
  color: var(--black);
  font-size: 0.875rem;
  line-height: 1.214;
}

.text b{
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.3125;
  display: block;
  margin: 10px 0;
}

.text small {
  font-style: italic;
  font-size: 0.75rem;
  line-height: 1.25;
  display: block;
  margin: 10px 0;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
